import { render, staticRenderFns } from "./EventOutcomeSelector.vue?vue&type=template&id=4b863be4&scoped=true"
import script from "./EventOutcomeSelector.vue?vue&type=script&lang=ts"
export * from "./EventOutcomeSelector.vue?vue&type=script&lang=ts"
import style0 from "./EventOutcomeSelector.vue?vue&type=style&index=0&id=4b863be4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b863be4",
  null
  
)

export default component.exports